
import { Component, Vue } from 'vue-property-decorator';
import OsSheet from '@/components/core/sheet/OsSheet.vue';
import OsSheetContent from '@/components/core/sheet/OsSheetContent.vue';
import { IReportContentCategory } from '@/models/application';
import { reportContentCategoriesApi } from '@/apis';
import OsLoadingIndicator from '@/components/core/OsLoadingIndicator.vue';
import OsAppuserForm from '@/components/shared/appusers/OsAppuserForm.vue';
import { AppDirtyUtil } from '@/utils/AppDirtyUtil';
import OsInternalUserForm from '@/components/shared/internalusers/OsInternalUserForm.vue';
import OsAlertBox from '@/components/core/OsAlertBox.vue';
import OsInternalUsersCustomers from '@/components/shared/internalusers/OsInternalUsersCustomers.vue';
import OsReportContentCategoryForm from '@/components/shared/reportcontentcategories/OsReportContentCategoryForm.vue';

@Component({
  components: {
    OsReportContentCategoryForm,
    OsInternalUsersCustomers,
    OsAlertBox,
    OsInternalUserForm,
    OsAppuserForm,
    OsLoadingIndicator,
    OsSheetContent,
    OsSheet
  }
})
export default class SettingsReportContentCategoryById extends Vue {
  appDirtyUtil: AppDirtyUtil = new AppDirtyUtil();

  category: IReportContentCategory | null = null;

  loading = false;

  async mounted() {
    this.category = (await reportContentCategoriesApi.getById(
      this.$route.params.id
    )) as IReportContentCategory;

    this.appDirtyUtil.init(this.category);
  }

  async onSave() {
    this.loading = true;
    try {
      this.category = (await reportContentCategoriesApi.update(
        this.category!
      )) as IReportContentCategory;

      this.appDirtyUtil.init(this.category);
    } finally {
      this.loading = false;
    }
  }

  async onDelete() {
    if (
      await this.$global.dialogs.confirm(
        'Confirm deletion',
        `Are you sure you want to delete the report segment ${
          this.category!.name
        }?`
      )
    ) {
      const result = await reportContentCategoriesApi.deleteById(
        this.category!.id
      );
      if (result) {
        await this.$router.push(`/settings/reportcontentcategories`);
      }
    }
  }

  undoClicked() {
    this.category = this.appDirtyUtil.getOriginalObject();
    this.appDirtyUtil.init(this.category);
  }
}
